export default {
  // ========== Matrix1View - Titles and texts ==========
  progressionOf: 'Progression of',
  by: 'by',
  of: 'of',
  viewOf: 'View of',
  without: 'without',
  noDataFor: 'No',
  associatedToThisProfile: 'associated to this profile',
  draft: 'Draft',
  doesNotHaveAny: 'Does not have any',
  created: 'created',
  noData: 'No',

  // ========== Tooltips and specific messages ==========
  competencesWithoutCyclesInfo: 'These {competences} are irregular in the {egressProfile}, you can change their {cycle} or delete them; so they do not affect the configuration of the {matrix}.',
  competenceBelongsToSuperiorLevel: 'The {competence} belongs to a superior {cognitiveLevel} than the one found in the next {cycle}.',
  multipleSelectionTooltip: 'To use multiple selection, hold down the Ctrl key and then select the items you want to add.',

  // ========== Confirmations ==========
  deleteCompetenceAssociationConfirm: 'Are you sure you want to delete the association of this instance of "{competence} in the {egressProfile}"?',
  deleteActionIrreversible: 'This action cannot be reversed!',
}
